import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Account from '../Account'
import Loading from './../Loading'

import * as accountActions from '../../ducks/account'

class AccountContainer extends React.Component {
  render() {
    if (!this.props.currentAccount) {
      return <Loading />
    }

    return (
      <Account
        currentAccount={this.props.currentAccount}
        onUpdateProfile={this.props.accountActions.update}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    currentAccount: state.account.get('currentAccount')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AccountContainer.js